<div class="container-modal-confirm-changes d-flex flex-column">
    <i class="btn-close icon-edponline-Bop-071" (click)="dismissModal(false)" aria-hidden="true"></i>

    <ng-container *ngIf="!!data.collection.type">
        <h1 class="container-modal-confirm-changes-title">{{ customTitle }}</h1>
    </ng-container>
    <ng-container *ngIf="!!data.title">
        <h1 class="container-modal-confirm-changes-title">{{ data.title }}</h1>
    </ng-container>

    <ng-container *ngIf="!!data.message">
        <p class="container-modal-confirm-changes-description">{{ data.message }}</p>
    </ng-container>

    <p *ngIf="!!data.collection.change" class="container-modal-confirm-changes-description" [innerHTML]="customDescription"></p>

    <div class="container-modal-confirm-changes-buttons d-flex flex-column-reverse flex-md-row justify-content-between">
        <button class="btn edp-btn-secondary mt-2 mt-md-0" (click)="closeModal(false)">
            {{ "pt.edp.edponline.modal.contract.confirm.changes.cancel" | translate }}
        </button>
        <button class="btn btn-primary" autofocus (click)="advance()">
            {{ "pt.edp.edponline.modal.contract.confirm.changes.confirm" | translate }}
        </button>
    </div>
</div>
